jQuery(document).ready(function ($) {
    if (jQuery('.preaprobare-calculator').length > 0) {

        const preaprobareRules = {
            sumaImprumut: jQuery('#preaprobare-loan-sum-slider').val(),
            salariu: true,
            perioada: 24,
            nume: '',
            prenume: '',
            email: '',
            domiciliu: '',
            telefon: '',
            locuinta: 'chirie',
            alteCredite: true,
            'scop-imprumut': '',
            'data-nastere': '',
            'ipoteca-lunara': 0,
            'salariu-net': 0,
            'credit-ramas': 0,
            'credit-lunar': 0,
            'chirie-lunara': 0,
            'sumaAlteCrediteRamas': 0,
            scor: 100,
        }

        jQuery('.preaprobare-steps button.primary').on('click', function (e) {
            e.preventDefault();

            var currentStep = parseInt(jQuery('.calculator-preaprobare').attr('data-step'));
            const hasErrors = validateFields(currentStep);


            if (hasErrors) return;

            var newStep = currentStep + 1;

            jQuery(this).parents('.preaprobare-calculator').hide().next().show();
            jQuery('.calculator-preaprobare').attr('data-step', newStep);
            if (newStep > 2) {
                jQuery('.complete-journey').show();
            }

            // Scroll to the top of the form
            jQuery('html, body').animate({
                scrollTop: jQuery('.preaprobare-steps-container').offset().top - jQuery('#masthead .top-row').outerHeight() - 20
            }, 500);

        });
        jQuery('.preaprobare-steps button.white').on('click', function (e) {

            e.preventDefault();

            var currentStep = parseInt(jQuery('.calculator-preaprobare').attr('data-step'));
            var newStep = currentStep - 1;
            jQuery(this).parents('.preaprobare-calculator').hide().prev().show();
            jQuery('.calculator-preaprobare').attr('data-step', newStep);


            if (currentStep < 3) {
                jQuery('.complete-journey').hide();
            }

            // Scroll to the top of the form
            jQuery('html, body').animate({
                scrollTop: jQuery('.preaprobare-steps-container').offset().top - jQuery('#masthead .top-row').outerHeight()
            }, 500);
        });

        jQuery('#preaprobare-loan-sum-slider').on('input', function () {
            jQuery('#preaprobare-loan-sum').val(jQuery(this).val());
            preaprobareRules.sumaImprumut = jQuery(this).val();
        });
        jQuery('#preaprobare-primesti-salariu').on('change', function () {
            const salariuLunar = jQuery(this).val() == 'da' ? true : false;
            preaprobareRules.salariu = salariuLunar;

            if (salariuLunar) {
                jQuery('#preaprobare-salariu-net').parents('.calculator-field').removeClass('hidden');
                jQuery('#preaprobare-scop-imprumut').parents('.calculator-field').removeClass('hidden');
            } else {
                jQuery('#preaprobare-salariu-net').parents('.calculator-field').addClass('hidden');
                jQuery('#preaprobare-scop-imprumut').parents('.calculator-field').addClass('hidden');
            }

        });

        jQuery('#preaprobare-scop-imprumut').on('change', function () {
            const scopImprumut = jQuery(this).val();
            preaprobareRules['scop-imprumut'] = scopImprumut;
        });
        jQuery('#preaprobare-perioada-imprumut').on('change', function () {
            const perioada = jQuery(this).val();
            preaprobareRules.perioada = parseInt(perioada, 10);
        });

        jQuery('#preprobare-locuinta').on('change', function () {
            const locuinta = jQuery(this).val();
            preaprobareRules.locuinta = locuinta;

            if (locuinta == 'chirie') {
                jQuery('#preaprobare-chirie-lunara').parents('.calculator-field').removeClass('hidden');
                jQuery('#preaprobare-ipoteca-lunara').parents('.calculator-field').addClass('hidden');
            } else if (locuinta == 'ipoteca') {
                jQuery('#preaprobare-chirie-lunara').parents('.calculator-field').addClass('hidden');
                jQuery('#preaprobare-ipoteca-lunara').parents('.calculator-field').removeClass('hidden');
            } else {
                jQuery('#preaprobare-chirie-lunara').parents('.calculator-field').addClass('hidden');
                jQuery('#preaprobare-ipoteca-lunara').parents('.calculator-field').addClass('hidden');
            }

        });

        jQuery('#preaprobare-alte-credite').on('change', function () {
            const alteCredite = jQuery(this).val() == 'da' ? true : false;
            preaprobareRules.alteCredite = alteCredite;

            if (!alteCredite) {
                jQuery('#preaprobare-credit-ramas').parents('.calculator-field').addClass('hidden');
            } else {
                jQuery('#preaprobare-credit-ramas').parents('.calculator-field').removeClass('hidden');
            }
        });

        ['salariu-net', 'scop-imprumut', 'nume', 'prenume', 'data-nastere', 'email', 'domiciliu', 'telefon', 'chirie-lunara', 'credit-lunar', 'credit-ramas', 'ipoteca-lunara'].forEach(function (item) {
            jQuery('#preaprobare-' + item).on('input', function () {
                preaprobareRules[item] = jQuery(this).val();
            });
        });

        jQuery('.complete-journey a').on('click', async function (e) {
            e.preventDefault();

            // console.log("Initializing the calculation...");

            const hasErrors = validateFields();

            if (hasErrors) {
                // Find the first occurence of the empty field and scroll to it
                var firstEntry = jQuery('.field-entry.error');

                // Check if multiple
                if (firstEntry.length > 1) {
                    firstEntry = firstEntry.first();
                }


                jQuery('html, body').animate({
                    scrollTop: firstEntry.offset().top - jQuery('#masthead').outerHeight()
                }, 800);



                alert('Va rugam sa completati toate campurile.');
                return;
            }

            if (preaprobareRules['salariu-net'] <= 0) {
                alert('Va rugam sa completati un salariu net valid.');
                return;
            }

            // Check if data-nastere is a valid date and if the user has at least 18 years old
            const dataNastere = new Date(preaprobareRules['data-nastere']);
            const today = new Date();
            var age = today.getFullYear() - dataNastere.getFullYear();
            const m = today.getMonth() - dataNastere.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < dataNastere.getDate())) {
                age--;
            }

            if (age < 18) {
                alert('Va rugam sa completati o data de nastere valida.');
                return;
            }

            jQuery('.complete-journey a').attr('disabled', true);
            jQuery('.complete-journey a span').text('Calculăm...');


            // if (preaprobareRules.salariu == false) {
            //     alert('Nu puteti aplica pentru un imprumut daca nu primiti salariu lunar.');
            //     return;
            // }

            // if (preaprobareRules.scopImprumut == '') {
            //     alert('Va rugam sa alegeti un scop pentru imprumut.');
            //     return;
            // }

            // const option = calculPreaprobare(preaprobareRules);
            const user = prepareUserData();

            const calculation = await saveLead(user);

            jQuery('.complete-journey a').removeAttr('disabled');

            const option = calculation.debtToIncome > 50 ? 'error' : 'success';

            if (option === 'success') {
                window.dataLayer = window.dataLayer || [];
                var eventSent = window.dataLayer.push({
                    event: 'generate_prelead_pf'
                });
            } else {
                window.dataLayer = window.dataLayer || [];
                var eventSent = window.dataLayer.push({
                    event: 'generate_prelead_pf_neg'
                });
            }

            // console.log({ eventSent })

            // const options = ['success', 'error'];

            // const randomOption = options[Math.floor(Math.random() * options.length)];

            // Remove the hidden class for the randomOption 
            jQuery('.preaprobare-' + option).removeClass('hidden');

            // Hide the calculator
            jQuery('.preaprobare-steps-container').addClass('hidden');

            // Scroll the page to the top of .preaprobare-results element
            jQuery('html, body').animate({
                scrollTop: jQuery('.preaprobare-results').offset().top - jQuery('#masthead').outerHeight()
            }, 300);

            // console.log(preaprobareRules);

            jQuery('.calculator-preaprobare h2, .calculator-preaprobare h2 + div').addClass('hidden');


        });


        jQuery('.preaprobare-retry').on('click', function (e) {
            e.preventDefault();

            // Remove the hidden class for the randomOption 
            jQuery('.preaprobare-success').addClass('hidden');
            jQuery('.preaprobare-error').addClass('hidden');

            // Hide the calculator 
            jQuery('.preaprobare-steps-container').removeClass('hidden');

            // Scroll the page to the top of .preaprobare-results element
            jQuery('html, body').animate({
                scrollTop: jQuery('.preaprobare-steps-container').offset().top - jQuery('#masthead').outerHeight()
            }, 300);


        });


        function prepareUserData() {
            const userData = {
                'firstName': preaprobareRules.prenume,
                'lastName': preaprobareRules.nume,
                'email': preaprobareRules.email,
                'hasSalary': preaprobareRules.salariu,
                'netSalary': parseInt(preaprobareRules['salariu-net'], 10),
                'loanAmount': parseInt(preaprobareRules.sumaImprumut, 10),
                'loanScope': preaprobareRules['scop-imprumut'],
                'loanMonthlyAmount': parseInt(preaprobareRules['credit-lunar'], 10),
                'rentCost': parseInt(preaprobareRules['chirie-lunara'], 10),
                'mortgageMonthlyAmount': parseInt(preaprobareRules['ipoteca-lunara'], 10),
                'outstandingCreditAmount': parseInt(preaprobareRules['credit-ramas'], 10),
                'period': preaprobareRules.perioada,
                'birthdate': preaprobareRules['data-nastere'],
                'phone': preaprobareRules.telefon,
                'house': preaprobareRules.locuinta,
                'address': preaprobareRules.domiciliu,
                'score': preaprobareRules.scor,
                'hasLoans': preaprobareRules.alteCredite,
            };

            // Change the params so they fit the internal API
            switch (userData.loanScope) {
                case 'refinantare':
                    userData.loanScope = 'LOAN_REFINANCING';
                    break;
                case 'nunta':
                    userData.loanScope = 'WEDDING';
                    break;
                case 'card-credit':
                    userData.loanScope = 'CREDIT_CARD';
                    break;
                case 'auto':
                    userData.loanScope = 'CAR';
                    break;
                case 'achizitii-majore':
                    userData.loanScope = 'BIG_PROCUREMENT';
                    break;
                case 'amenajare-casa':
                    userData.loanScope = 'HOUSEHOLD';
                    break;
                case 'vacanta':
                    userData.loanScope = 'HOLIDAY';
                    break;
                case 'tratament':
                    userData.loanScope = 'MEDICAL';
                    break;
                case 'afacere':
                    userData.loanScope = 'BUSINESS';
                    break;
                case 'alte':
                    userData.loanScope = 'OTHER';
                    break;
            }

            switch (userData.house) {
                case 'chirie':
                    userData.house = 'RENT';
                    break;
                case 'ipoteca':
                    userData.house = 'MORTGAGE';
                    break;
                case 'proprietate':
                    userData.house = 'PRIVATE_PROPERTY';
                    break;
                case 'parinti':
                    userData.house = 'WITH_PARENTS';
                    break;
            }

            // Change the phone format to have the country code and number separately in the object
            var phone = userData.phone;
            // Get the country code
            const countryCode = '+' + jQuery('#preaprobare-telefon').attr('data-country-code');

            // Remove the country code from the phone number
            phone = phone.replace(countryCode, '');

            // Add the country code and phone number to the object
            userData.phone = {
                countryCode: countryCode,
                number: phone
            };

            return userData;
        }

        function validateFields(step = 0) {

            const fields = [
                'loan-sum-slider',
                'salariu-net',
                'perioada',
                'scop-imprumut',
                'nume',
                'prenume',
                'email',
                'data-nastere',
                'telefon',
                'locuinta',
                'domiciliu',
                'ipoteca-lunara',
                'chirie-lunara',
                'credit-lunar',
                'credit-ramas',
                'termeni-conditii',
            ];

            var hasErrors = false;

            // console.log({ step })

            // Go through each field and check if it's empty. If empty, add the error class to the parent element
            fields.forEach(function (item, index) {



                // Remove all the previous errors
                jQuery('#error-field-' + item).remove();


                // If index is set to 1, it means that we are on the first step and we need to validate only the first 4 fields

                if (step === 1 && index > 3) {
                    return false;
                }

                // If index is set to 2, it means that we are on the second step and we need to validate only the last 4 fields

                if (step === 2 && index > 12) {
                    return false;
                }

                // If the field is empty, add the error class to the parent element
                var isError = (item !== 'chirie-lunara' && item !== 'credit-lunar' && item !== 'ipoteca-lunara' && item !== 'credit-ramas') && preaprobareRules[item] === '';

                // Validate email field
                if (item === 'email') {
                    isError = !validateEmail(preaprobareRules[item]);
                }
                // Validate email field
                if (item === 'telefon') {
                    isError = !validatePhone(preaprobareRules[item]);
                }

                if (item === 'salariu-net' && preaprobareRules[item] === '0' || preaprobareRules[item] <= 0) {
                    isError = true;
                }

                if (item === 'credit-lunar' || item === 'credit-ramas') {
                    isError = (preaprobareRules.alteCredite) && (preaprobareRules[item] === '' || preaprobareRules[item] === '0' || preaprobareRules[item] == 0);
                }

                if (item === 'chirie-lunara') {
                    isError = (preaprobareRules.locuinta === 'chirie') && (preaprobareRules[item] === '' || preaprobareRules[item] === '0' || preaprobareRules[item] == 0);
                }
                if (item === 'ipoteca-lunara') {
                    isError = (preaprobareRules.locuinta === 'ipoteca') && (preaprobareRules[item] === '' || preaprobareRules[item] === '0' || preaprobareRules[item] == 0);
                }
                if (item === 'termeni-conditii') {
                    // Check if the checkbox is checked
                    isError = !jQuery('#preaprobare-termeni-conditii').is(':checked');
                }


                if (isError) {
                    console.log("Error on field: " + item);
                    jQuery('#preaprobare-' + item).parents('.field-entry').addClass('error');
                    jQuery('#preaprobare-' + item).parents('.field-entry').append('<div class="error-message" id="error-field-' + item + '">Vă rugăm să completați acest câmp.</div>');
                    hasErrors = true;
                } else {
                    jQuery('#preaprobare-' + item).parents('.field-entry').removeClass('error');
                    jQuery('#error-field-' + item).remove();
                }

            });

            return hasErrors;
        }

        function calculPreaprobare(values) {

            console.log("Starting the calculation...");

            const type = values['scop-imprumut'];

            if (type !== 'refinantare' && type !== 'card-credit') {
                const sumaPlatiLunare = (parseFloat(values['credit-lunar']) + parseFloat(values['chirie-lunara']) + parseFloat(values['ipoteca-lunara'])) / 20;

                const formula1 = (sumaPlatiLunare + (parseFloat(values.sumaImprumut) / parseFloat(values.perioada))) / (parseFloat(values['salariu-net']) / 20) * 100;

                preaprobareRules.scor = formula1;

                if (formula1 > 50) {
                    return 'error';
                } else {
                    return 'success';
                }

            } else {
                const sumaPlatiLunare = (parseFloat(values['chirie-lunara']) + parseFloat(values['ipoteca-lunara'])) / 20;

                const formula2 = (sumaPlatiLunare + (parseFloat(values.sumaImprumut) / parseFloat(values.perioada))) / (parseFloat(values['salariu-net']) / 20) * 100;

                preaprobareRules.scor = formula2;

                if (formula2 > 50) {
                    return 'error';
                } else {
                    return 'success';
                }
            }
        }

        async function saveLead(user) {
            const apiUrl = 'https://api.app.fagura.com/api/marketing-and-sales/pre-assessment';
            // const apiUrl = 'https://api.demo.fagura.com/api/marketing-and-sales/pre-assessment';

            // Do fetch post request to the API with the user data
            const res = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(user),
            })
                .then(response => response.json())
                .then(data => {
                    return data;
                    // console.log('Success:', data);

                })
                .catch((error) => {
                    console.error('Error:', error);
                });

            return res;
        }

        function validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        }

        function validatePhone(phone) {
            // If #preaprobare-telefon data-country-code is 373 => 8 digits, else 10 digits
            var countryCode = jQuery('#preaprobare-telefon').attr('data-country-code');

            if (phone.length < 8) {
                return false;
            }

            if (countryCode === 373) {
                return phone.length === 12;
            } else if (countryCode === 40) {
                return phone.length === 13;
            }

            return true;

        }

    }
});